module.exports = __webpack_public_path__ + "img/35_8.05a013d3.png";